export default __webpack_public_path__ + "static/media/watch.497fffb9.svg";